var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row shops__list" },
    _vm._l(_vm.markets, function (market, index) {
      return _c("shop-item", {
        key: index,
        attrs: { market: market, mainlng: _vm.mainlng, lng: _vm.lng },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }